import { characterSelector, useHudStore } from "@/domains/hud/store";
import SpeakingIndicator from "@/domains/hud/components/indicator/SpeakingIndicator";

export default function HudSpeakingIndicatorConainter() {
  const character = useHudStore(characterSelector);

  if (!character?.isVoiceActive) return null;

  return <SpeakingIndicator on={Boolean(character?.isVoiceActive)} />;
}
